import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function SkillsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="skll_tags"
					label={t('DETAILS_SKILLS_FIELD_TAGS')}
					value={props.model.skll_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* WARNING */}
				<BooleanDescField
					name="skll_warning_desc"
					label={t('DETAILS_SKILLS_FIELD_WARNING')}
					value={props.model.skll_warning_desc}
					icon="alert-outline"
					color="#ffae42"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* BLOCKED */}
				<BooleanDescField
					name="skll_blocked_desc"
					label={t('DETAILS_SKILLS_FIELD_BLOCKED')}
					value={props.model.skll_blocked_desc}
					icon="cancel"
					color="red"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
